import { render, staticRenderFns } from "./period-store-info.vue?vue&type=template&id=30f28172&scoped=true"
import script from "./period-store-info.vue?vue&type=script&lang=js"
export * from "./period-store-info.vue?vue&type=script&lang=js"
import style0 from "./period-store-info.vue?vue&type=style&index=0&id=30f28172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f28172",
  null
  
)

export default component.exports